import {Filters as _Filters, searchLabel} from "_components/filters";
import {makeFilters} from "_utils/filters";
import {ActiveFilter} from "_components/filters/ToggleFilter";
import {SearchFilter} from "_components/filters/SearchFilter";
import {useEffect} from "react";
import {ViewSelector} from "_pages/service/queue/components/table/ViewSelector";
import {observable} from "@legendapp/state";


export const {filters, $onFilterChange} = makeFilters([
    {
        label: 'Listar',
        name: 'viewSelector',
        init: undefined,
        component: ViewSelector,
    },
]);

export const $keepFilters = observable(false);

export const Filters = () => {
    useEffect(() => {
        if($keepFilters.get()) {
            $keepFilters.set(false);
            return;
        }

        $onFilterChange
            .get()
            .resetFilters();
    }, []);

    const onChange = (value: any, badge?: string) => $onFilterChange.assign({ ['viewSelector']: { value, badge } });

    return <ViewSelector {...{onChange, current: $onFilterChange.get()['viewSelector'].value ?? 'online'}}/>;
}
